import { GraphQLError } from "graphql"

import { fetchLBGSharedOwnershipCompanyList } from "../api/lbg_shared_ownership_company_list"
import { Resolvers } from "../generated/resolvers"

const resolvers: Resolvers = {
  Query: {
    lbgSharedOwnershipCompanies: async () => {
      const results = await fetchLBGSharedOwnershipCompanyList()

      if (results instanceof GraphQLError) {
        throw results
      }

      return results?.map(item => ({
        __typename: 'LBGSharedOwnershipCompanyOption',
        label: item.value!,
        value: item.key!,
      })) || null
    }
  }
}

export default resolvers